var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],staticStyle:{"margin-bottom":"10px !important","margin-top":"-18px !important"}},[_c('span',{staticClass:"file-note red--text"},[_vm._v(" "+_vm._s(_vm.getMessage())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }